import React from "react";
import { Layout } from "antd";
import CustomHeader from "../presentation/components/CustomHeader/CustomHeader.component";
import { MainContent } from "../presentation/components/MainContent/MainContent.component";
import Sidebar from "../presentation/components/Sidebar/Sidebar.component";
import { useIsMobile } from "../services/responsiveUtils";
import { UserAuth } from "../middleware/UserContext/UserContext.middleware";
import "./AppLayout.styles.css";

const { Sider, Content, Footer } = Layout;

const AppLayout: React.FC = () => {
  const isMobile = useIsMobile();
  const { currentUser } = UserAuth();

  return (
    <Layout className="app-layout-outer">
      {(!isMobile && currentUser) && (
        <Sider
          theme="light"
          className="sider"
          breakpoint="md"
          width="auto"
        >
          <Sidebar />
        </Sider>
      )}
      <Layout>
        <CustomHeader />
        <Content className="content">
          <MainContent />
        </Content>
        <Footer className="footer"></Footer>
      </Layout>
    </Layout>
  );
};

export default AppLayout;